'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RecordPropType = require('ui-addon-conversations/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _WidgetHeaderContent = require('../widget-header/WidgetHeaderContent');

var _WidgetHeaderContent2 = _interopRequireDefault(_WidgetHeaderContent);

var _WidgetHeaderButton = require('../WidgetHeaderButton');

var _WidgetHeaderButton2 = _interopRequireDefault(_WidgetHeaderButton);

var _hubspotConstants = require('hubspot.constants.icons');

var _hubspotConstants2 = _interopRequireDefault(_hubspotConstants);

var _WidgetHeaderThreadListButton = require('../widget-header/WidgetHeaderThreadListButton');

var _WidgetHeaderThreadListButton2 = _interopRequireDefault(_WidgetHeaderThreadListButton);

var _WidgetHeaderStyleWrapper = require('../../presentation-components/WidgetHeaderStyleWrapper');

var _WidgetHeaderStyleWrapper2 = _interopRequireDefault(_WidgetHeaderStyleWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WidgetHeader = function (_React$Component) {
  _inherits(WidgetHeader, _React$Component);

  function WidgetHeader(props) {
    _classCallCheck(this, WidgetHeader);

    var _this = _possibleConstructorReturn(this, (WidgetHeader.__proto__ || Object.getPrototypeOf(WidgetHeader)).call(this, props));

    _this.state = {
      showAvailabilityMessage: false
    };
    _this.getAvailabilityMessage = _this.getAvailabilityMessage.bind(_this);
    _this.getShowAvailabilityMessage = _this.getShowAvailabilityMessage.bind(_this);
    return _this;
  }

  _createClass(WidgetHeader, [{
    key: 'getAvailabilityMessage',
    value: function getAvailabilityMessage() {
      return this.props.preview ? this.props.previewResponseTimeText : this.props.typicalResponseTimeMessage || this.props.officeHoursMessage;
    }
  }, {
    key: 'getShowAvailabilityMessage',
    value: function getShowAvailabilityMessage() {
      var _props = this.props,
          showAvailabilityMessage = _props.showAvailabilityMessage,
          typicalResponseTimeMessage = _props.typicalResponseTimeMessage,
          officeHoursMessage = _props.officeHoursMessage,
          preview = _props.preview,
          previewResponseTimeText = _props.previewResponseTimeText;


      var showRealAvailabilityMessage = showAvailabilityMessage && (typicalResponseTimeMessage || officeHoursMessage);

      if (showRealAvailabilityMessage) {
        return true;
      }

      return Boolean(preview && !!previewResponseTimeText);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          isThreadAssigned = _props2.isThreadAssigned,
          chatHeadingConfig = _props2.chatHeadingConfig,
          chatHeadingResponders = _props2.chatHeadingResponders,
          coloring = _props2.coloring,
          mobile = _props2.mobile,
          inline = _props2.inline,
          onClose = _props2.onClose,
          showThreadListButton = _props2.showThreadListButton;


      return _react2.default.createElement(
        _WidgetHeaderStyleWrapper2.default,
        {
          mobile: mobile,
          coloring: coloring,
          inline: inline
        },
        _react2.default.createElement(_WidgetHeaderThreadListButton2.default, {
          coloring: coloring,
          showThreadList: this.props.showThreadList,
          showThreadListButton: showThreadListButton,
          unseenThreadsCountExcludingCurrentThread: this.props.unseenThreadsCountExcludingCurrentThread
        }),
        _react2.default.createElement(_WidgetHeaderContent2.default, {
          availabilityMessage: this.getAvailabilityMessage(),
          chatHeadingConfig: chatHeadingConfig,
          createNewThread: this.props.createNewThread,
          coloring: coloring,
          showStatusIndicator: isThreadAssigned,
          mobile: mobile,
          chatHeadingResponders: chatHeadingResponders,
          showAvailabilityMessage: this.getShowAvailabilityMessage(),
          viewingThreadList: this.props.viewingThreadList
        }),
        mobile && !inline && _react2.default.createElement(_WidgetHeaderButton2.default, {
          className: 'widget-close-button m-right-4',
          iconName: _hubspotConstants2.default.REMOVE,
          onClick: onClose,
          style: {
            fontSize: 20,
            width: 24
          }
        })
      );
    }
  }]);

  return WidgetHeader;
}(_react2.default.Component);

WidgetHeader.propTypes = {
  chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
  chatHeadingResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  coloring: (0, _RecordPropType2.default)('ColoringRecord').isRequired,
  createNewThread: _react.PropTypes.func.isRequired,
  inline: _react.PropTypes.bool.isRequired,
  isThreadAssigned: _react.PropTypes.bool,
  mobile: _react.PropTypes.bool,
  officeHoursMessage: _react.PropTypes.string,
  onClose: _react.PropTypes.func.isRequired,
  preview: _react.PropTypes.bool,
  previewResponseTimeText: _react.PropTypes.string,
  showAvailabilityMessage: _react.PropTypes.bool.isRequired,
  showThreadList: _react.PropTypes.func,
  showThreadListButton: _react.PropTypes.bool.isRequired,
  typicalResponseTimeMessage: _react.PropTypes.string,
  unseenThreadsCountExcludingCurrentThread: _react.PropTypes.number,
  viewingThreadList: _react.PropTypes.bool
};

WidgetHeader.defaultProps = {
  createNewThread: function createNewThread() {},
  inline: false,
  showThreadList: function showThreadList() {},
  unseenThreadsCountExcludingCurrentThread: 0
};

exports.default = WidgetHeader;
module.exports = exports['default'];